import { render, staticRenderFns } from "./moreVideoItem.vue?vue&type=template&id=05fa74ff&scoped=true&"
import script from "./moreVideoItem.vue?vue&type=script&lang=js&"
export * from "./moreVideoItem.vue?vue&type=script&lang=js&"
import style0 from "./moreVideoItem.vue?vue&type=style&index=0&id=05fa74ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa74ff",
  null
  
)

export default component.exports